var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"text-2xl mb-6"},[_vm._v("Liste des Sites")]),_c('v-col',{attrs:{"cols":"12"}},[_c('sites-table')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }